import React, { createContext, useContext, ReactNode } from 'react';
import { useAuth, AuthState, UserRole } from '@/hooks/useAuth';

interface AuthContextType extends AuthState {
  signUp: (email: string, password: string, metadata: {
    apelido: string;
    nome: string;
    celular?: string;
  }) => Promise<any>;
  signIn: (email: string, password: string) => Promise<any>;
  signOut: () => Promise<any>;
  resetPassword: (email: string) => Promise<any>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}

export { type UserRole };